import { render, staticRenderFns } from "./FhCard.vue?vue&type=template&id=dc17dd92&scoped=true&"
import script from "./FhCard.vue?vue&type=script&lang=js&"
export * from "./FhCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc17dd92",
  null
  
)

export default component.exports